import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/actions";
import { contact_us_data } from '../../redux/selectors';
import PointsOfInterest from "./PointsOfInterest";
// import ContactFormInputs from "./ContactFormInputs";

const Contact = () => {
    const dispatch = useDispatch();
    const data = useSelector(contact_us_data("contact_us"));

    useEffect(() => {
        if (!data || data.length === 0) {  
            dispatch(fetchData("contact_us","pages?path=/company-info/contact-us"));
        }
    }, [dispatch, data]);   

    console.log('contact us data ', data);    

    const point_of_int = data?.all_data?.en ?? [];

    return (
        <>
            <section className="hot-deals">            
                <div className="container container-lg">
                    <div className="row gy-4">
                        <div className="col-sm-7 p-20">                        
                            <div className="flex-between flex-wrap gap-8">
                                <h2 className="mb-0 text-blue flex-grow-1">CONTACT US</h2>    
                            </div> 
                        </div> 
                    </div>     
                    <div className="p-20">
                        <PointsOfInterest data={point_of_int} />

                        <div className="h-1 w-full bg-medium-grey line-margin"></div>

                        <h6 className="mb-0 text-blue">  
                            <p>Want to know more about Dhofar Global and our products? Get in touch!</p>
                        </h6>

                        {/* <ContactFormInputs /> */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;
